import { Collapse } from "antd";
import StatusIndicator from "./StatusIndicator";
import PreviewButton from "./PreviewButton";

const { Panel } = Collapse;

const LegalDocument = ({
  keyName,
  formTitle,
  filledFormData,
  formComponent: FormComponent,
  leagleForms,
  files,
  getLeagleFormPreviewData,
  application,
  aadharDetails,
  metaData,
  getAllJoiningFilledForms,
  setActivePanel,
  setIsFieldTouch,
  previewSetter,
  additionalProps = {},
}) => {
  
  const form = leagleForms.find(
    (f) => f.formName === formTitle && f?.isDocActive === true
  );

  return (
    <Panel
      header={
        <div className="w-100 d-flex justify-content-between align-items-center filter-group-gap flex-wrap">
          <div>
            {formTitle.toUpperCase()}<span className="text-danger">*</span>
          </div>
          <div className="d-flex flex-wrap filter-group-gap w-sm-100 justify-content-between align-items-center">
            <StatusIndicator indicator={filledFormData} />
            <PreviewButton
              getLeagleFormPreviewData={getLeagleFormPreviewData}
              files={files}
              leagleForms={leagleForms}
              formName={formTitle}
            />
          </div>
        </div>
      }
      key={keyName}
    >
      <FormComponent
        key={keyName}
        setIsFieldTouch={setIsFieldTouch}
        form={form}
        filledForm={filledFormData}
        application={application}
        aadharDetails={aadharDetails}
        metaData={metaData}
        getAllJoiningFilledForms={getAllJoiningFilledForms}
        setActivePanel={setActivePanel}
        {...previewSetter}
        {...additionalProps}
      />
    </Panel>
  );
};

export default LegalDocument;
